/**
 * Phase 1 + Phase 2 ABI fragments for Election.sol.
 * Phase 1: 5 functions + 2 constants for candidacy (getCycle, startTime, checkVotingPeriod, getCycleCandidates, beCandidate, CYCLE_UNIT, VOTE_PERIOD, candidates, ownersOfCycle).
 * Phase 2: vote, voteWithStake, withdrawDnm, voterStake, voterStakeCount, getStakedDnm.
 * See: arandao-docs/pipeline/DAO-FOUND-02/idocs/voting/api-contract.md §Phase 2 ABI fragments
 */
export const ELECTION_ABI = [
  {
    inputs: [],
    name: "getCycle",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startTime",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "checkVotingPeriod",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_cycle", type: "uint256" }],
    name: "getCycleCandidates",
    outputs: [
      {
        components: [
          { internalType: "address", name: "addr", type: "address" },
          { internalType: "uint256", name: "vote_count", type: "uint256" },
        ],
        internalType: "struct Election.Candidate[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "beCandidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "CYCLE_UNIT",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VOTE_PERIOD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "candidate", type: "address" },
      { internalType: "uint256", name: "cycle", type: "uint256" },
    ],
    name: "candidates",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "cycle", type: "uint256" },
      { internalType: "uint256", name: "index", type: "uint256" },
    ],
    name: "ownersOfCycle",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  // ─── Phase 3 fragments (DAO-FOUND-03) ────────────────────────────────────
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "isOwner",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  // ─── Phase 2 fragments (DAO-FOUND-02) ────────────────────────────────────
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "voterStake",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "uint256", name: "cycle", type: "uint256" },
    ],
    name: "voterStakeCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "getStakedDnm",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "candidate", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "vote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "candidate", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "voteWithStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawDnm",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;
